module.exports = __webpack_public_path__ + "img/action-RNY.4403b085.svg";